//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
	name: "CardItem",
	components: {},
	props: {
		location: Object,
		index: Number,
	},
	data() {
		return {
			letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
		};
	},
	computed: {
		...mapGetters([
			"tags",
			"activeTags"
		]),
		directionsHref() {
			let address = `${this.location.address.street} ${this.location.address.city} ${this.location.address.state} ${this.location.address.zipCode}`;
			return `https://www.google.com/maps/place/${encodeURI(address)}`;
		},
	},
	methods: {
		
	},
	created() {
		
	},
};
